import { render, staticRenderFns } from "./12.vue?vue&type=template&id=dafc9aa4&scoped=true&"
var script = {}
import style0 from "./12.vue?vue&type=style&index=0&id=dafc9aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafc9aa4",
  null
  
)

export default component.exports